import { style } from 'typestyle';
import { IMGHEIGHT } from '../TopCard/TopCard.styles';

const detailsPanel = style({
  background: '#f6f6f6',
  paddingTop: 6,
  paddingRight: 10,
  minHeight: IMGHEIGHT,
  boxSizing: 'border-box',
});

export default {
  detailsPanel,
};
